<template>
    <div :name="name" class="row color-buttons">
        <div v-for="(color, key) in colors" class="color-button" :style="{backgroundColor: color}" v-on:click="newValue = key" :class="key.toString() === newValue.toString() ? 'selected' : ''" v-bind:key="key"></div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'colorbuttons',
    mixins: [
        Default
    ],
    props: ['name', 'value', 'colors'],
    data() {
        return {
            newValue: ''
        };
    },
    created() {
        this.newValue = this.value;
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    }
};
</script>

<style lang="scss" scoped>
    .color-buttons {
        /*background-color: #f2f5fa;*/
        margin: 0;
        /*border: 1px solid #e8ebf0;*/
        /*border-radius: 5px;*/

        .color-button {
            border: 3px solid black;
            border-radius: 4px;
            width: calc(2.5em - 3px);
            height: calc(2.5em - 3px);
            cursor: pointer;
            margin: 0 .5em 0 0;
        }

        .selected {
            border-color: $primary-color;
        }
    }
</style>